import { Box } from '@mui/material';

import { MortgageDocumentsWorkspace } from '@/components/Profile/MortgageDocumentsWorkspace';
import { CommonDialog } from '../Common/CommonDialog';

type ManageDocumentsModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

export const ManageDocumentsModal = ({
  isOpen,
  onClose,
}: ManageDocumentsModalProps) => {
  return (
    <CommonDialog
      isOpen={isOpen}
      title="Manage documents"
      icon="fa-light fa-file"
      onClose={onClose}
    >
      <Box sx={{ maxHeight: 'min(70vh, 640px)', overflowY: 'auto' }}>
        <MortgageDocumentsWorkspace
          variant="embedded"
          showOpenApplicationButton={false}
        />
      </Box>
    </CommonDialog>
  );
};
